<style lang="less" scoped>
    .page_con.login{
        width:100vw;
        height:100vh;
        overflow: hidden;
        background:url("../assets/images/bg1.png") no-repeat;
        background-size: 100% 100%;
    }
    .content{
        width:100%;
        margin-top:25vh;
        >img{
            width:70%;
            height:auto;
            display: block;
            margin: 0 auto 8vh;
        }
        .start_con{
            img{
                width:40vw;
                height:auto;
                display: block;
                margin:10vh auto;
            }
        }
        .login_con{
            width:80%;
            padding: 0.7rem 0 .3rem;
            margin:0 auto;
            background:#fff;
            border-radius: .3rem;
            .login_row{
                width:100%;
                height:5vh;
                display: flex;
                align-items: center;
                justify-content: center;
                .row_lf{
                    width:25vw;
                    font-size: .36rem;
                    color:#333;
                    text-align: right;
                    letter-spacing: 3px;
                }
                input{
                    width:2rem;
                    height:4vh;
                    border:none;
                    outline: none;
                    padding:0 .1rem;
                    font-size: .28rem;
                    color:#333;
                    box-shadow: 0px 0px 3px 2px #999 inset;
                }
            }
            .login_row.login_pic{
                width:100%;
                height:auto;
                img{
                    width:40vw;
                    height:auto;
                    display: block;
                    margin:5vh auto 2vh;
                }
            }
        }
    }
    .auth_con{
        width:100vw;
        height:auto;
        position: fixed;
        left: 0;
        bottom: 0;
        z-index: 11;
        background:#F8B857;
        padding: .3rem .4rem;
        display: flex;
        align-items: center;
        justify-content: space-between;
        .search{
            padding:.05rem .3rem;
            border:.02rem solid #eee;
            color:#ddd;
            border-radius: 50px;
            a{
                color:#ddd;
                display: block;
                width:100%;
                height:100%;
            }
        }
    }
    .logError{
        width:70vw;
        height:8vh;
        position: fixed;
        top:15vh;
        left: 15vw;
        z-index: 9999;
        text-align: center;
        line-height: 8vh;
        font-size: .32rem;
        color:#fff;
        background:rgba(0,0,0,.5);
        border-radius: .1rem;
    }
</style>
<template>
    <div class="page_con login">
        <div class="content">
            <img src="../assets/images/title-homepage.png" alt="">
            <div v-if="status == 'wait'" class="start_con">
                <img v-if="autoLogin" @click="login" src="../assets/images/start-button.png" alt="">
                <img v-else @click="status=1" src="../assets/images/start-button.png" alt="">
            </div>
            <div v-else class="login_con">
                <div class="login_row">
                    <div class="row_lf">學校編號</div>
                    <span>：</span>
                    <input type="text" v-model="school">
                </div>
                <div class="login_row">
                    <div class="row_lf">用戶編號</div>
                    <span>：</span>
                    <input type="text" v-model="account">
                </div>
                <div class="login_row">
                    <div class="row_lf">密&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;碼</div>
                    <span>：</span>
                    <input type="password" v-model="password">
                </div>
                <div class="login_row login_pic">
                    <img src="../assets/images/login-button.png" @click="login" alt="">
                </div>
            </div>
        </div>
        <div class="auth_con">
            <span>創辦：何萬貫教授</span>
            <div class="search"><a href="https://notice.easydo123.com" target="_blank">查詢</a></div>
        </div>
        <div class="logError" v-if="showLogError">
            账号或密码错误
        </div>
    </div>
</template>
<script>
export default {
    data(){
        return {
            showLogError:false,
            autoLogin:false,     //是否自动登录  
            status:'wait',
            school:'',
            account:'',
            password:'',
        }
    },
    mounted(){
        console.log(this.autoLogin)
    },
    methods:{
        login(){
            let vm = this;
            let data = {params:{
                txtSchool:this.school,
                txtName:this.account,
                txtPswd:this.password,
                rest_key:1,
            }}
            vm.$http.get('/User/login.html',this.autoLogin?{params:{
                txtSchool:'demo',
                txtName:'demo1',
                txtPswd:'demo1',
                rest_key:1,
            }}:data)
            .then(res=>{
                if(res.data.code == 1){
                    vm.$router.push('/index')
                }else{
                    vm.showLogError = true;
                    setTimeout(function(){
                        vm.showLogError = false;
                    },2000)
                }
            })
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/components/login.vue